export const componentRef = 'box-folder-list';
